export function AxonMark({ size=20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="var(--color-brand)" strokeWidth="1.5"/>
      <path d="M4 15l3.5-5 3 3L14 8l2.5 4" stroke="var(--color-brand)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="17.5" cy="6.5" r="2" fill="var(--color-brand)"/>
    </svg>
  );
}
